import React, { ReactNode } from 'react';
import UQIcon from '../icon';
import UQButton from '../button';
import './style.scss';

export interface UQModalProps {
  children: ReactNode;
  header: string;
  buttoncancel?: string;
  buttonOk?: string;
  iconOk?: string;
  style?: 'warning' | 'info' | 'success' | 'error' | 'neutral';
  icon?: string;
  show: boolean;
  onClose: () => void;
  onOk: () => void;
  fullscreen?: boolean;
}

const Modal: React.FC<UQModalProps> = ({
  children,
  header,
  buttoncancel,
  buttonOk,
  iconOk,
  style = 'neutral',
  icon,
  show,
  onClose,
  onOk,
  fullscreen = false,
}) => {
  if (!show) return null;

  return (
    <div className={`modal-background${fullscreen ? ' fullscreen' : ''}`}>
      <div className={`modal${style && style !== 'neutral' ? ` ${style}` : ''}${fullscreen ? ' fullscreen' : ''}`}>
        {/* Close Icon */}
        <div className="modal-close" onClick={onClose}>
          <UQIcon icon="x" />
        </div>

        {/* Icon Section (optional) */}
        {style && style !== 'neutral' && icon && (
          <div className="modal-icon">
            <div className={`icon-wrapper ${style}`}>
              <UQIcon icon={icon} />
            </div>
          </div>
        )}

        {/* Header */}
        <div className={`modal-header${style && style !== 'neutral' ? ` ${style}` : ''}`}>{header}</div>

        {/* Body */}
        <div className="modal-body">{children}</div>

        {/* Buttons */}
        <div className="modal-buttons">
          {buttoncancel && (
            <UQButton type="secondary" size="large" onClick={onClose}>
              {buttoncancel}
            </UQButton>
          )}
          {buttonOk && (
            <UQButton type="primary" size="large" onClick={onOk} icon={iconOk} iconPosition="right">
              {buttonOk}
            </UQButton>
          )}
        </div>
      </div>
    </div>
  );
};

export default Modal;
